var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({staticClass:"scroll-up",attrs:{"x-large":"","fab":"","bottom":"","right":"","fixed":""},on:{"click":function($event){return _vm.goUp()}}},on),[_c('v-icon',[_vm._v("mdi-chevron-up")])],1)]}}])},[_c('span',[_vm._v("Go up!")])])}
var staticRenderFns = []

export { render, staticRenderFns }